module.exports = __webpack_public_path__ + "static/media/logo_zing_white.73b0d31a.png";